var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMortarboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#232323",
  d: "M12.316 3.07a.75.75 0 0 0-.633 0L.433 8.32A.75.75 0 0 0 .47 9.696l11.25 4.5a.75.75 0 0 0 .558 0L21 10.71v8.79a1.5 1.5 0 0 0-1.5 1.5v3H24v-3a1.5 1.5 0 0 0-1.5-1.5v-9.392l1.03-.412a.75.75 0 0 0 .037-1.376zm-.317 9.62L2.636 8.947 12 4.577l9.363 4.37z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#232323",
  d: "M6.264 13.548a.75.75 0 0 0-.984.49l-.75 2.55a.75.75 0 0 0 .441.908l6.75 2.7a.75.75 0 0 0 .558 0l6.75-2.7a.75.75 0 0 0 .441-.907l-.75-2.55a.75.75 0 0 0-.984-.49L12 15.698zm-.102 2.81.33-1.122 5.244 1.966a.75.75 0 0 0 .528 0l5.244-1.966.33 1.122L12 18.69z"
})));
export default SvgMortarboard;